import React, { useState } from 'react'
import {
  Row,
  Col,
  Input,
  Label,
  Button
} from 'reactstrap'
import _ from 'lodash'

const langList = [ 'en', 'de', 'nl', 'it' ]

const MultilingualInput = props => {
  const [ buttonLang, updateButtonLang ] = useState( props.selectedLanguage )

  return (
    <>
      <Row 
        className='mb-2'
        style={{ 
          display: "flex",
          alignItems: "center",
          justifyContent: props.label ? "space-between" : "flex-end" 
        }}>
        {
          props.label && <Col sm={ 6 }>
            <Label className='mb-0'>{ props.label }</Label>
          </Col>
        }
        <div 
          style={{ 
            padding: "0 15px",
            width: "max-content" }} >
          {
            langList.map( lang => <Button
              type='button'
              className='mr-1 mb-1'
              key={`${lang}`}
              color={ lang === buttonLang ? 'success' : 'primary' }
              onClick={ () => updateButtonLang( lang ) }
              >
              { props.isDutchAsRomanian && lang === 'nl' ? 'ro' : lang }</Button> )
          }
        </div>
      </Row>
      <Input
        type={ props.inputType? props.inputType: 'textarea' }
        value={ props.value ? props.value[ buttonLang ] : '' }
        onChange={ e => {
          let tmp = _.cloneDeep( props.value )
          tmp[ buttonLang ] = e.target.value
          props.onChangeValue( tmp )
        }}
      />
    </>
  )
}

export default MultilingualInput